/* tslint:disable */
/* tslint:disable */
import { Injectable, Inject, Optional } from '@angular/core';
import { Http, Response } from '@angular/http';
import { SDKModels } from './SDKModels';
import { BaseLoopBackApi } from '../core/base.service';
import { LoopBackConfig } from '../../lb.config';
import { LoopBackAuth } from '../core/auth.service';
import { LoopBackFilter, } from '../../models/BaseModels';
import { JSONSearchParams } from '../core/search.params';
import { ErrorHandler } from '../core/error.service';
import { Subject } from 'rxjs/Subject';
import { Observable } from 'rxjs/Rx';

import { SFPayProcess } from '../../models/SFPayProcess';
import { SocketConnection } from '../../sockets/socket.connections';


/**
 * Api services for the `SFPayProcess` model.
 */
@Injectable()
export class SFPayProcessApi extends BaseLoopBackApi {

  constructor(
    @Inject(Http) protected http: Http,
    @Inject(SocketConnection) protected connection: SocketConnection,
    @Inject(SDKModels) protected models: SDKModels,
    @Inject(LoopBackAuth) protected auth: LoopBackAuth,
    @Inject(JSONSearchParams) protected searchParams: JSONSearchParams,
    @Optional() @Inject(ErrorHandler) protected errorHandler: ErrorHandler
  ) {

    super(http, connection, models, auth, searchParams, errorHandler);

  }

  /**
  * <em>
        * (The remote method definition does not provide any description.)
        * </em>
  *
  * @param {String} periodCode
  *
  * @param {Date} paydate
  *
  * @param {object} cont
  *
  * @returns {object} An empty reference that will be
  *   populated with the actual data once the response is returned
  *   from the server.
  *
  * <em>
  * (The remote method definition does not provide any description.
  * This usually means the response is a `SFPayProcess` object.)
  * </em>
  */
  public getEmpPayPeriod(periodCode: any = {}, paydate: any = {}, customHeaders?: Function): Observable<any> {
    let _method: string = "GET";
    let _url: string = LoopBackConfig.getPath() + "/" + LoopBackConfig.getApiVersion() +
      "/SFPayProcesses/getEmpPayPeriod";
    let _routeParams: any = {};
    let _postBody: any = {};
    let _urlParams: any = {};
    if (typeof periodCode !== 'undefined' && periodCode !== null) _urlParams.periodCode = periodCode;
    if (typeof paydate !== 'undefined' && paydate !== null) _urlParams.paydate = paydate;
    let result = this.request(_method, _url, _routeParams, _urlParams, _postBody, null, customHeaders);
    return result;
  }

  /**
   * <em>
         * (The remote method definition does not provide any description.)
         * </em>
   *
   * @param {String} periodCode
   *
   * @param {Date} paydate
   *
   * @param {String} dispjams
   *
   * @param {object} cont
   *
   * @returns {object} An empty reference that will be
   *   populated with the actual data once the response is returned
   *   from the server.
   *
   * <em>
   * (The remote method definition does not provide any description.
   * This usually means the response is a `SFPayProcess` object.)
   * </em>
   */
  public getAllowDeductPeriod(periodCode: any = {}, paydate: any = {}, dispjams: any = {}, customHeaders?: Function): Observable<any> {
    let _method: string = "GET";
    let _url: string = LoopBackConfig.getPath() + "/" + LoopBackConfig.getApiVersion() +
      "/SFPayProcesses/getAllowDeductPeriod"; 
    let _routeParams: any = {};
    let _postBody: any = {};
    let _urlParams: any = {};
    if (typeof periodCode !== 'undefined' && periodCode !== null) _urlParams.periodCode = periodCode;
    if (typeof paydate !== 'undefined' && paydate !== null) _urlParams.paydate = paydate;
    if (typeof dispjams !== 'undefined' && dispjams !== null) _urlParams.dispjams = dispjams;
    let result = this.request(_method, _url, _routeParams, _urlParams, _postBody, null, customHeaders);
    return result;
  }

  /**
   * <em>
         * (The remote method definition does not provide any description.)
         * </em>
   *
   * @param {object} data Request data.
   *
   *  - `params` – `{Object}` -
   *
   * @returns {object} An empty reference that will be
   *   populated with the actual data once the response is returned
   *   from the server.
   *
   * <em>
   * (The remote method definition does not provide any description.
   * This usually means the response is a `SFPayProcess` object.)
   * </em>
   */
  public uploadComponent(params: any, customHeaders?: Function): Observable<any> {
    let _method: string = "POST";
    let _url: string = LoopBackConfig.getPath() + "/" + LoopBackConfig.getApiVersion() +
      "/SFPayProcesses/uploadComponent";
    let _routeParams: any = {};
    let _postBody: any = {};
    let _urlParams: any = {};
    if (typeof params !== 'undefined' && params !== null) _urlParams.params = params;
    let result = this.request(_method, _url, _routeParams, _urlParams, _postBody, null, customHeaders);
    return result;
  }

  /**
   * <em>
         * (The remote method definition does not provide any description.)
         * </em>
   *
   * @param {Object} filter
   *
   * @param {Object} cont
   *
   * @returns {object} An empty reference that will be
   *   populated with the actual data once the response is returned
   *   from the server.
   *
   * <em>
   * (The remote method definition does not provide any description.
   * This usually means the response is a `SFPayProcess` object.)
   * </em>
   */
  public download(filter: any = {}, customHeaders?: Function): Observable<any> {
    let _method: string = "GET";
    let _url: string = LoopBackConfig.getPath() + "/" + LoopBackConfig.getApiVersion() +
      "/SFPayProcesses/download";
    let _routeParams: any = {};
    let _postBody: any = {};
    let _urlParams: any = {};
    if (typeof filter !== 'undefined' && filter !== null) _urlParams.filter = filter;
    let result = this.request(_method, _url, _routeParams, _urlParams, _postBody, null, customHeaders);
    return result;
  }

  /**
   * <em>
         * (The remote method definition does not provide any description.)
         * </em>
   *
   * @param {String} periodCode
   *
   * @param {Date} paydate
   *
   * @param {String} dispjams
   *
   * @param {object} cont
   *
   * @returns {object} An empty reference that will be
   *   populated with the actual data once the response is returned
   *   from the server.
   *
   * <em>
   * (The remote method definition does not provide any description.
   * This usually means the response is a `SFPayProcess` object.)
   * </em>
   */
  public getAllowDeductPeriod2(periodCode: any = {}, paydate: any = {}, dispjams: any = {}, customHeaders?: Function): Observable<any> {
    let _method: string = "GET";
    let _url: string = LoopBackConfig.getPath() + "/" + LoopBackConfig.getApiVersion() +
      "/SFPayProcesses/getAllowDeductPeriod2";
    let _routeParams: any = {};
    let _postBody: any = {};
    let _urlParams: any = {};
    if (typeof periodCode !== 'undefined' && periodCode !== null) _urlParams.periodCode = periodCode;
    if (typeof paydate !== 'undefined' && paydate !== null) _urlParams.paydate = paydate;
    if (typeof dispjams !== 'undefined' && dispjams !== null) _urlParams.dispjams = dispjams;
    let result = this.request(_method, _url, _routeParams, _urlParams, _postBody, null, customHeaders);
    return result;
  }

  /**
   * <em>
         * (The remote method definition does not provide any description.)
         * </em>
   *
   * @param {String} periodCode
   *
   * @param {object} cont
   *
   * @returns {object} An empty reference that will be
   *   populated with the actual data once the response is returned
   *   from the server.
   *
   * <em>
   * (The remote method definition does not provide any description.
   * This usually means the response is a `SFPayProcess` object.)
   * </em>
   */
  public getReviewData(periodCode: any = {}, customHeaders?: Function): Observable<any> {
    let _method: string = "GET";
    let _url: string = LoopBackConfig.getPath() + "/" + LoopBackConfig.getApiVersion() +
      "/SFPayProcesses/getReviewData";
    let _routeParams: any = {};
    let _postBody: any = {};
    let _urlParams: any = {};
    if (typeof periodCode !== 'undefined' && periodCode !== null) _urlParams.periodCode = periodCode;
    let result = this.request(_method, _url, _routeParams, _urlParams, _postBody, null, customHeaders);
    return result;
  }

  /**
   * <em>
         * (The remote method definition does not provide any description.)
         * </em>
   *
   * @param {String} periodCode
   *
   * @param {String} paydate
   *
   * @param {object} cont
   *
   * @returns {object} An empty reference that will be
   *   populated with the actual data once the response is returned
   *   from the server.
   *
   * <em>
   * (The remote method definition does not provide any description.
   * This usually means the response is a `SFPayProcess` object.)
   * </em>
   */
  public getSummaryPayroll(periodCode: any = {}, paydate: any = {}, customHeaders?: Function): Observable<any> {
    let _method: string = "GET";
    let _url: string = LoopBackConfig.getPath() + "/" + LoopBackConfig.getApiVersion() +
      "/SFPayProcesses/getSummaryPayroll";
    let _routeParams: any = {};
    let _postBody: any = {};
    let _urlParams: any = {};
    if (typeof periodCode !== 'undefined' && periodCode !== null) _urlParams.periodCode = periodCode;
    if (typeof paydate !== 'undefined' && paydate !== null) _urlParams.paydate = paydate;
    let result = this.request(_method, _url, _routeParams, _urlParams, _postBody, null, customHeaders);
    return result;
  }

  /**
   * <em>
         * (The remote method definition does not provide any description.)
         * </em>
   *
   * @param {String} periodCode
   *
   * @param {String} empStatus
   *
   * @param {String} gender
   *
   * @param {String} religion
   *
   * @param {String} marital
   *
   * @param {String} skip
   *
   * @param {String} limit
   *
   * @param {object} cont
   *
   * @returns {object} An empty reference that will be
   *   populated with the actual data once the response is returned
   *   from the server.
   *
   * <em>
   * (The remote method definition does not provide any description.
   * This usually means the response is a `SFPayProcess` object.)
   * </em>
   */
  public getemppayrolldata(periodCode: any = {}, empStatus: any = {}, gender: any = {}, religion: any = {}, marital: any = {}, skip: any = {}, limit: any = {}, customHeaders?: Function): Observable<any> {
    let _method: string = "GET";
    let _url: string = LoopBackConfig.getPath() + "/" + LoopBackConfig.getApiVersion() +
      "/SFPayProcesses/getemppayrolldata";
    let _routeParams: any = {};
    let _postBody: any = {};
    let _urlParams: any = {};
    if (typeof periodCode !== 'undefined' && periodCode !== null) _urlParams.periodCode = periodCode;
    if (typeof empStatus !== 'undefined' && empStatus !== null) _urlParams.empStatus = empStatus;
    if (typeof gender !== 'undefined' && gender !== null) _urlParams.gender = gender;
    if (typeof religion !== 'undefined' && religion !== null) _urlParams.religion = religion;
    if (typeof marital !== 'undefined' && marital !== null) _urlParams.marital = marital;
    if (typeof skip !== 'undefined' && skip !== null) _urlParams.skip = skip;
    if (typeof limit !== 'undefined' && limit !== null) _urlParams.limit = limit;
    let result = this.request(_method, _url, _routeParams, _urlParams, _postBody, null, customHeaders);
    return result;
  }

  /**
   * <em>
         * (The remote method definition does not provide any description.)
         * </em>
   *
   * @param {object} cont
   *
   * @returns {object} An empty reference that will be
   *   populated with the actual data once the response is returned
   *   from the server.
   *
   * <em>
   * (The remote method definition does not provide any description.
   * This usually means the response is a `SFPayProcess` object.)
   * </em>
   */
  public getReligion(customHeaders?: Function): Observable<any> {
    let _method: string = "GET";
    let _url: string = LoopBackConfig.getPath() + "/" + LoopBackConfig.getApiVersion() +
      "/SFPayProcesses/getReligion";
    let _routeParams: any = {};
    let _postBody: any = {};
    let _urlParams: any = {};
    let result = this.request(_method, _url, _routeParams, _urlParams, _postBody, null, customHeaders);
    return result;
  }

  /**
   * <em>
         * (The remote method definition does not provide any description.)
         * </em>
   *
   * @param {object} cont
   *
   * @returns {object} An empty reference that will be
   *   populated with the actual data once the response is returned
   *   from the server.
   *
   * <em>
   * (The remote method definition does not provide any description.
   * This usually means the response is a `SFPayProcess` object.)
   * </em>
   */
  public getMarital(customHeaders?: Function): Observable<any> {
    let _method: string = "GET";
    let _url: string = LoopBackConfig.getPath() + "/" + LoopBackConfig.getApiVersion() +
      "/SFPayProcesses/getMarital";
    let _routeParams: any = {};
    let _postBody: any = {};
    let _urlParams: any = {};
    let result = this.request(_method, _url, _routeParams, _urlParams, _postBody, null, customHeaders);
    return result;
  }

  /**
   * <em>
         * (The remote method definition does not provide any description.)
         * </em>
   *
   * @param {String} empId
   *
   * @param {object} cont
   *
   * @returns {object} An empty reference that will be
   *   populated with the actual data once the response is returned
   *   from the server.
   *
   * <em>
   * (The remote method definition does not provide any description.
   * This usually means the response is a `SFPayProcess` object.)
   * </em>
   */
  public getempdetail(empId: any = {}, customHeaders?: Function): Observable<any> {
    let _method: string = "GET";
    let _url: string = LoopBackConfig.getPath() + "/" + LoopBackConfig.getApiVersion() +
      "/SFPayProcesses/getempdetail";
    let _routeParams: any = {};
    let _postBody: any = {};
    let _urlParams: any = {};
    if (typeof empId !== 'undefined' && empId !== null) _urlParams.empId = empId;
    let result = this.request(_method, _url, _routeParams, _urlParams, _postBody, null, customHeaders);
    return result;
  }

  /**
   * <em>
         * (The remote method definition does not provide any description.)
         * </em>
   *
   * @param {object} cont
   *
   * @returns {object} An empty reference that will be
   *   populated with the actual data once the response is returned
   *   from the server.
   *
   * <em>
   * (The remote method definition does not provide any description.
   * This usually means the response is a `SFPayProcess` object.)
   * </em>
   */
  public getAllowDeduct(customHeaders?: Function): Observable<any> {
    let _method: string = "GET";
    let _url: string = LoopBackConfig.getPath() + "/" + LoopBackConfig.getApiVersion() +
      "/SFPayProcesses/getAllowDeduct";
    let _routeParams: any = {};
    let _postBody: any = {};
    let _urlParams: any = {};
    let result = this.request(_method, _url, _routeParams, _urlParams, _postBody, null, customHeaders);
    return result;
  }

  /**
   * <em>
         * (The remote method definition does not provide any description.)
         * </em>
   *
   * @param {object} data Request data.
   *
   *  - `periodCode` – `{String}` -
   *
   *  - `params` – `{Object}` -
   *
   * @returns {object} An empty reference that will be
   *   populated with the actual data once the response is returned
   *   from the server.
   *
   * <em>
   * (The remote method definition does not provide any description.
   * This usually means the response is a `SFPayProcess` object.)
   * </em>
   */
  public updateempcomperiod(periodCode: any = {}, params: any, customHeaders?: Function): Observable<any> {
    let _method: string = "POST";
    let _url: string = LoopBackConfig.getPath() + "/" + LoopBackConfig.getApiVersion() +
      "/SFPayProcesses/updateempcomperiod";
    let _routeParams: any = {};
    let _postBody: any = {
      params: params
    };
    let _urlParams: any = {};
    if (typeof periodCode !== 'undefined' && periodCode !== null) _urlParams.periodCode = periodCode;
    let result = this.request(_method, _url, _routeParams, _urlParams, _postBody, null, customHeaders);
    return result;
  }

  /**
   * <em>
         * (The remote method definition does not provide any description.)
         * </em>
   *
   * @param {String} periodCode
   *
   * @param {String} search
   *
   * @param {number} skip
   *
   * @param {number} limit
   *
   * @param {object} cont
   *
   * @returns {object} An empty reference that will be
   *   populated with the actual data once the response is returned
   *   from the server.
   *
   * <em>
   * (The remote method definition does not provide any description.
   * This usually means the response is a `SFPayProcess` object.)
   * </em>
   */
  public getActiveEmployee(periodCode: any = {}, search: any = {}, skip: any = {}, limit: any = {}, customHeaders?: Function): Observable<any> {
    let _method: string = "GET";
    let _url: string = LoopBackConfig.getPath() + "/" + LoopBackConfig.getApiVersion() +
      "/SFPayProcesses/getActiveEmployee";
    let _routeParams: any = {};
    let _postBody: any = {};
    let _urlParams: any = {};
    if (typeof periodCode !== 'undefined' && periodCode !== null) _urlParams.periodCode = periodCode;
    if (typeof search !== 'undefined' && search !== null) _urlParams.search = search;
    if (typeof skip !== 'undefined' && skip !== null) _urlParams.skip = skip;
    if (typeof limit !== 'undefined' && limit !== null) _urlParams.limit = limit;
    let result = this.request(_method, _url, _routeParams, _urlParams, _postBody, null, customHeaders);
    return result;
  }

  /**
   * <em>
         * (The remote method definition does not provide any description.)
         * </em>
   *
   * @param {String} periodCode
   *
   * @param {String} payDate
   *
   * @param {String} search
   *
   * @param {String} filters
   *
   * @param {number} skip
   *
   * @param {number} limit
   *
   * @param {object} cont
   *
   * @returns {object} An empty reference that will be
   *   populated with the actual data once the response is returned
   *   from the server.
   *
   * <em>
   * (The remote method definition does not provide any description.
   * This usually means the response is a `SFPayProcess` object.)
   * </em>
   */
  public getActiveAllEmployee(periodCode: any = {}, payDate: any = {}, search: any = {}, filters: any = {}, skip: any = {}, limit: any = {}, customHeaders?: Function): Observable<any> {
    let _method: string = "GET";
    let _url: string = LoopBackConfig.getPath() + "/" + LoopBackConfig.getApiVersion() +
      "/SFPayProcesses/getActiveAllEmployee";
    let _routeParams: any = {};
    let _postBody: any = {};
    let _urlParams: any = {};
    if (typeof periodCode !== 'undefined' && periodCode !== null) _urlParams.periodCode = periodCode;
    if (typeof payDate !== 'undefined' && payDate !== null) _urlParams.payDate = payDate;
    if (typeof search !== 'undefined' && search !== null) _urlParams.search = search;
    if (typeof filters !== 'undefined' && filters !== null) _urlParams.filters = filters;
    if (typeof skip !== 'undefined' && skip !== null) _urlParams.skip = skip;
    if (typeof limit !== 'undefined' && limit !== null) _urlParams.limit = limit;
    let result = this.request(_method, _url, _routeParams, _urlParams, _postBody, null, customHeaders);
    return result;
  }

  /**
   * <em>
         * (The remote method definition does not provide any description.)
         * </em>
   *
   * @param {object} cont
   *
   * @returns {object} An empty reference that will be
   *   populated with the actual data once the response is returned
   *   from the server.
   *
   * <em>
   * (The remote method definition does not provide any description.
   * This usually means the response is a `SFPayProcess` object.)
   * </em>
   */
  public paidPayroll(customHeaders?: Function): Observable<any> {
    let _method: string = "GET";
    let _url: string = LoopBackConfig.getPath() + "/" + LoopBackConfig.getApiVersion() +
      "/SFPayProcesses/paidPayroll";
    let _routeParams: any = {};
    let _postBody: any = {};
    let _urlParams: any = {};
    let result = this.request(_method, _url, _routeParams, _urlParams, _postBody, null, customHeaders);
    return result;
  }

  /**
   * <em>
         * (The remote method definition does not provide any description.)
         * </em>
   *
   * @param {String} periodCode
   *
   * @param {object} cont
   *
   * @returns {object} An empty reference that will be
   *   populated with the actual data once the response is returned
   *   from the server.
   *
   * <em>
   * (The remote method definition does not provide any description.
   * This usually means the response is a `SFPayProcess` object.)
   * </em>
   */
  public paidPayroll2(periodCode: any = {}, customHeaders?: Function): Observable<any> {
    let _method: string = "GET";
    let _url: string = LoopBackConfig.getPath() + "/" + LoopBackConfig.getApiVersion() +
      "/SFPayProcesses/paidPayroll2";
    let _routeParams: any = {};
    let _postBody: any = {};
    let _urlParams: any = {};
    if (typeof periodCode !== 'undefined' && periodCode !== null) _urlParams.periodCode = periodCode;
    let result = this.request(_method, _url, _routeParams, _urlParams, _postBody, null, customHeaders);
    return result;
  }

  /**
   * <em>
         * (The remote method definition does not provide any description.)
         * </em>
   *
   * @param {String} periodCode
   *
   * @param {object} cont
   *
   * @returns {object} An empty reference that will be
   *   populated with the actual data once the response is returned
   *   from the server.
   *
   * <em>
   * (The remote method definition does not provide any description.
   * This usually means the response is a `SFPayProcess` object.)
   * </em>
   */
  public process(periodCode: any = {}, customHeaders?: Function): Observable<any> {
    let _method: string = "GET";
    let _url: string = LoopBackConfig.getPath() + "/" + LoopBackConfig.getApiVersion() +
      "/SFPayProcesses/process";
    let _routeParams: any = {};
    let _postBody: any = {};
    let _urlParams: any = {};
    if (typeof periodCode !== 'undefined' && periodCode !== null) _urlParams.periodCode = periodCode;
    let result = this.request(_method, _url, _routeParams, _urlParams, _postBody, null, customHeaders);
    return result;
  }

  /**
   * <em>
         * (The remote method definition does not provide any description.)
         * </em>
   *
   * @param {object} data Request data.
   *
   *  - `periodCode` – `{String}` -
   *
   *  - `ListEmpID` – `{String}` -
   *
   * @returns {object} An empty reference that will be
   *   populated with the actual data once the response is returned
   *   from the server.
   *
   * <em>
   * (The remote method definition does not provide any description.
   * This usually means the response is a `SFPayProcess` object.)
   * </em>
   */
  public processPayrollQueue(periodCode: any = {}, ListEmpID: any = '', customHeaders?: Function): Observable<any> {
    let _method: string = "POST";
    let _url: string = LoopBackConfig.getPath() + "/" + LoopBackConfig.getApiVersion() +
      "/SFPayProcesses/processPayrollQueue";
    let _routeParams: any = {};
    let _postBody: any = {
      periodCode: periodCode,
      ListEmpID: ListEmpID
    };
    let _urlParams: any = {};
    let result = this.request(_method, _url, _routeParams, _urlParams, _postBody, null, customHeaders);
    return result;
  }

  /**
   * <em>
         * (The remote method definition does not provide any description.)
         * </em>
   *
   * @param {String} periodCode
   *
   * @param {String} empId
   *
   * @param {object} dataUpdate
   *
   * @param {object} cont
   *
   * @returns {object} An empty reference that will be
   *   populated with the actual data once the response is returned
   *   from the server.
   *
   * <em>
   * (The remote method definition does not provide any description.
   * This usually means the response is a `SFPayProcess` object.)
   * </em>
   */
  public processByEmpId(periodCode: any, empId: any, dataUpdate: any = {}, customHeaders?: Function): Observable<any> {
    let _method: string = "GET";
    let _url: string = LoopBackConfig.getPath() + "/" + LoopBackConfig.getApiVersion() +
      "/SFPayProcesses/processByEmpId";
    let _routeParams: any = {};
    let _postBody: any = {};
    let _urlParams: any = {};
    if (typeof periodCode !== 'undefined' && periodCode !== null) _urlParams.periodCode = periodCode;
    if (typeof empId !== 'undefined' && empId !== null) _urlParams.empId = empId;
    if (typeof dataUpdate !== 'undefined' && dataUpdate !== null) _urlParams.dataUpdate = dataUpdate;
    let result = this.request(_method, _url, _routeParams, _urlParams, _postBody, null, customHeaders);
    return result;
  }

  /**
   * <em>
         * (The remote method definition does not provide any description.)
         * </em>
   *
   * @param {String} periodCode
   *
   * @param {object} dataUpdate
   *
   * @param {object} cont
   *
   * @returns {object} An empty reference that will be
   *   populated with the actual data once the response is returned
   *   from the server.
   *
   * <em>
   * (The remote method definition does not provide any description.
   * This usually means the response is a `SFPayProcess` object.)
   * </em>
   */
  public processRecall(periodCode: any, dataUpdate: any = {}, customHeaders?: Function): Observable<any> {
    let _method: string = "GET";
    let _url: string = LoopBackConfig.getPath() + "/" + LoopBackConfig.getApiVersion() +
      "/SFPayProcesses/processRecall";
    let _routeParams: any = {};
    let _postBody: any = {};
    let _urlParams: any = {};
    if (typeof periodCode !== 'undefined' && periodCode !== null) _urlParams.periodCode = periodCode;
    if (typeof dataUpdate !== 'undefined' && dataUpdate !== null) _urlParams.dataUpdate = dataUpdate;
    let result = this.request(_method, _url, _routeParams, _urlParams, _postBody, null, customHeaders);
    return result;
  }

  /**
   * <em>
         * (The remote method definition does not provide any description.)
         * </em>
   *
   * @param {String} periodCode
   *
   * @param {String} empId
   *
   * @param {object} cont
   *
   * @returns {object} An empty reference that will be
   *   populated with the actual data once the response is returned
   *   from the server.
   *
   * <em>
   * (The remote method definition does not provide any description.
   * This usually means the response is a `SFPayProcess` object.)
   * </em>
   */
  public processPerID(periodCode: any, empId: any, customHeaders?: Function): Observable<any> {
    let _method: string = "GET";
    let _url: string = LoopBackConfig.getPath() + "/" + LoopBackConfig.getApiVersion() +
      "/SFPayProcesses/processPerID";
    let _routeParams: any = {};
    let _postBody: any = {};
    let _urlParams: any = {};
    if (typeof periodCode !== 'undefined' && periodCode !== null) _urlParams.periodCode = periodCode;
    if (typeof empId !== 'undefined' && empId !== null) _urlParams.empId = empId;
    let result = this.request(_method, _url, _routeParams, _urlParams, _postBody, null, customHeaders);
    return result;
  }

  /**
   * <em>
         * (The remote method definition does not provide any description.)
         * </em>
   *
   * @param {String} empId
   *
   * @param {String} code
   *
   * @param {String} value
   *
   * @param {object} cont
   *
   * @returns {object} An empty reference that will be
   *   populated with the actual data once the response is returned
   *   from the server.
   *
   * <em>
   * (The remote method definition does not provide any description.
   * This usually means the response is a `SFPayProcess` object.)
   * </em>
   */
  public updateempcomp(empId: any = {}, code: any = {}, value: any = {}, customHeaders?: Function): Observable<any> {
    let _method: string = "GET";
    let _url: string = LoopBackConfig.getPath() + "/" + LoopBackConfig.getApiVersion() +
      "/SFPayProcesses/updateempcomp";
    let _routeParams: any = {};
    let _postBody: any = {};
    let _urlParams: any = {};
    if (typeof empId !== 'undefined' && empId !== null) _urlParams.empId = empId;
    if (typeof code !== 'undefined' && code !== null) _urlParams.code = code;
    if (typeof value !== 'undefined' && value !== null) _urlParams.value = value;
    let result = this.request(_method, _url, _routeParams, _urlParams, _postBody, null, customHeaders);
    return result;
  }

  /**
   * <em>
         * (The remote method definition does not provide any description.)
         * </em>
   *
   * @param {String} periodCode
   *
   * @param {object} cont
   *
   * @returns {object} An empty reference that will be
   *   populated with the actual data once the response is returned
   *   from the server.
   *
   * <em>
   * (The remote method definition does not provide any description.
   * This usually means the response is a `SFPayProcess` object.)
   * </em>
   */
  public verifyprocess(periodCode: any = {}, customHeaders?: Function): Observable<any> {
    let _method: string = "GET";
    let _url: string = LoopBackConfig.getPath() + "/" + LoopBackConfig.getApiVersion() +
      "/SFPayProcesses/verifyprocess";
    let _routeParams: any = {};
    let _postBody: any = {};
    let _urlParams: any = {};
    if (typeof periodCode !== 'undefined' && periodCode !== null) _urlParams.periodCode = periodCode;
    let result = this.request(_method, _url, _routeParams, _urlParams, _postBody, null, customHeaders);
    return result;
  }

  public verifyprocessWithPayDate(periodCode: any = {}, payDate: any, customHeaders?: Function): Observable<any> {
    let _method: string = "GET";
    let _url: string = LoopBackConfig.getPath() + "/" + LoopBackConfig.getApiVersion() +
      "/SFPayProcesses/verifyprocess";
    let _routeParams: any = {};
    let _postBody: any = {};
    let _urlParams: any = {};
    if (typeof periodCode !== 'undefined' && periodCode !== null) _urlParams.periodCode = periodCode;
    if (typeof payDate !== 'undefined' && payDate !== null) _urlParams.payDate = payDate;
    let result = this.request(_method, _url, _routeParams, _urlParams, _postBody, null, customHeaders);
    return result;
  }

  /**
   * <em>
         * (The remote method definition does not provide any description.)
         * </em>
   *
   * @param {Object} params
   *
   * @param {object} cont
   *
   * @returns {object} An empty reference that will be
   *   populated with the actual data once the response is returned
   *   from the server.
   *
   * <em>
   * (The remote method definition does not provide any description.
   * This usually means the response is a `SFPayProcess` object.)
   * </em>
   */
  public getFeed(params: any = {}, customHeaders?: Function): Observable<any> {
    let _method: string = "GET";
    let _url: string = LoopBackConfig.getPath() + "/" + LoopBackConfig.getApiVersion() +
      "/SFPayProcesses/getFeed";
    let _routeParams: any = {};
    let _postBody: any = {};
    let _urlParams: any = {};
    if (typeof params !== 'undefined' && params !== null) _urlParams.params = params;
    let result = this.request(_method, _url, _routeParams, _urlParams, _postBody, null, customHeaders);
    return result;
  }

  /**
   * <em>
         * (The remote method definition does not provide any description.)
         * </em>
   *
   * @param {object} data Request data.
   *
   * This method expects a subset of model properties as request parameters.
   *
   * @returns {object} An empty reference that will be
   *   populated with the actual data once the response is returned
   *   from the server.
   *
   * Data properties:
   *
   *  - `result` – `{Object}` -
   */
  public updateSchedule(params: any, customHeaders?: Function): Observable<any> {
    let _method: string = "POST";
    let _url: string = LoopBackConfig.getPath() + "/" + LoopBackConfig.getApiVersion() +
      "/SFPayProcesses/updateSchedule";
    let _routeParams: any = {};
    let _postBody: any = {
      params: params
    };
    let _urlParams: any = {};
    let result = this.request(_method, _url, _routeParams, _urlParams, _postBody, null, customHeaders);
    return result;
  }

  /**
   * <em>
   * (The remote method definition does not provide any description.)
   * </em>
   *
   * @param {Object} params
   *
   * @param {object} cont
   *
   * @returns {object} An empty reference that will be
   *   populated with the actual data once the response is returned
   *   from the server.
   *
   * <em>
   * (The remote method definition does not provide any description.
   * This usually means the response is a `SFPayProcess` object.)
   * </em>
   */
  public uploadtempemp(params: any = {}, customHeaders?: Function): Observable<any> {
    let _method: string = "GET";
    let _url: string = LoopBackConfig.getPath() + "/" + LoopBackConfig.getApiVersion() +
      "/SFPayProcesses/uploadtempemp";
    let _routeParams: any = {};
    let _postBody: any = {};
    let _urlParams: any = {};
    if (typeof params !== 'undefined' && params !== null) _urlParams.params = params;
    let result = this.request(_method, _url, _routeParams, _urlParams, _postBody, null, customHeaders);
    return result;
  }

  /**
   * <em>
         * (The remote method definition does not provide any description.)
         * </em>
   *
   * @param {Object} params
   *
   * @param {object} cont
   *
   * @returns {object} An empty reference that will be
   *   populated with the actual data once the response is returned
   *   from the server.
   *
   * <em>
   * (The remote method definition does not provide any description.
   * This usually means the response is a `SFPayProcess` object.)
   * </em>
   */
  public uploadtemptax(params: any = {}, customHeaders?: Function): Observable<any> {
    let _method: string = "GET";
    let _url: string = LoopBackConfig.getPath() + "/" + LoopBackConfig.getApiVersion() +
      "/SFPayProcesses/uploadtemptax";
    let _routeParams: any = {};
    let _postBody: any = {};
    let _urlParams: any = {};
    if (typeof params !== 'undefined' && params !== null) _urlParams.params = params;
    let result = this.request(_method, _url, _routeParams, _urlParams, _postBody, null, customHeaders);
    return result;
  }

  /**
   * <em>
   * (The remote method definition does not provide any description.)
   * </em>
   *
   * @param {Object} params
   *
   * @param {object} cont
   *
   * @returns {object} An empty reference that will be
   *   populated with the actual data once the response is returned
   *   from the server.
   *
   * <em>
   * (The remote method definition does not provide any description.
   * This usually means the response is a `SFPayProcess` object.)
   * </em>
   */
  public downTempDataEmployee(params: any = {}, customHeaders?: Function): Observable<any> {
    let _method: string = "GET";
    let _url: string = LoopBackConfig.getPath() + "/" + LoopBackConfig.getApiVersion() +
      "/SFPayProcesses/downTempDataEmployee";
    let _routeParams: any = {};
    let _postBody: any = {};
    let _urlParams: any = {};
    if (typeof params !== 'undefined' && params !== null) _urlParams.params = params;
    let result = this.request(_method, _url, _routeParams, _urlParams, _postBody, null, customHeaders);
    return result;
  }

  /**
  * <em>
        * (The remote method definition does not provide any description.)
        * </em>
  *
  * @param {object} data Request data.
  *
  * This method expects a subset of model properties as request parameters.
  *
  * @returns {object} An empty reference that will be
  *   populated with the actual data once the response is returned
  *   from the server.
  *
  * <em>
  * (The remote method definition does not provide any description.
  * This usually means the response is a `SFPayProcess` object.)
  * </em>
  */
  public taxCalc(params: any, customHeaders?: Function): Observable<any> {
    let _method: string = "POST";
    let _url: string = LoopBackConfig.getPath() + "/" + LoopBackConfig.getApiVersion() +
      "/SFPayProcesses/taxCalc";
    let _routeParams: any = {};
    let _postBody: any = {
      params: params
    };
    let _urlParams: any = {};
    let result = this.request(_method, _url, _routeParams, _urlParams, _postBody, null, customHeaders);
    return result;
  }

  /**
   * <em>
         * (The remote method definition does not provide any description.)
         * </em>
   *
   * @param {String} code
   *
   * @param {object} cont
   *
   * @returns {object} An empty reference that will be
   *   populated with the actual data once the response is returned
   *   from the server.
   *
   * <em>
   * (The remote method definition does not provide any description.
   * This usually means the response is a `SFPayProcess` object.)
   * </em>
   */
  public taxOptionsValue(code: any = {}, customHeaders?: Function): Observable<any> {
    let _method: string = "GET";
    let _url: string = LoopBackConfig.getPath() + "/" + LoopBackConfig.getApiVersion() +
      "/SFPayProcesses/taxOptionsValue";
    let _routeParams: any = {};
    let _postBody: any = {};
    let _urlParams: any = {};
    if (typeof code !== 'undefined' && code !== null) _urlParams.code = code;
    let result = this.request(_method, _url, _routeParams, _urlParams, _postBody, null, customHeaders);
    return result;
  }

  /**
   * <em>
         * (The remote method definition does not provide any description.)
         * </em>
   *
   * @param {String} periodCode
   *
   * @param {object} cont
   *
   * @returns {object} An empty reference that will be
   *   populated with the actual data once the response is returned
   *   from the server.
   *
   * <em>
   * (The remote method definition does not provide any description.
   * This usually means the response is a `SFPayProcess` object.)
   * </em>
   */
  public verifyEmployeeDataSettings(periodCode: any, customHeaders?: Function): Observable<any> {
    let _method: string = "GET";
    let _url: string = LoopBackConfig.getPath() + "/" + LoopBackConfig.getApiVersion() +
      "/SFPayProcesses/verifyEmployeeDataSettings";
    let _routeParams: any = {};
    let _postBody: any = {};
    let _urlParams: any = {};
    if (typeof periodCode !== 'undefined' && periodCode !== null) _urlParams.periodCode = periodCode;
    let result = this.request(_method, _url, _routeParams, _urlParams, _postBody, null, customHeaders);
    return result;
  }

  /**
   * The name of the model represented by this $resource,
   * i.e. `SFPayProcess`.
   */
  public getModelName() {
    return "SFPayProcess";
  }
}



// WEBPACK FOOTER //
// ./src/shared/sdk/services/custom/SFPayProcess.ts